import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../OurCourses/firebase';
import "./assessor.css";

function AssessorMentorApply() {
  const [formData, setFormData] = useState({ 
    email: '',
    name: '',
    contactNo: '',
    correspondentAddress: '',
    nicPassportNo: '',
    academicQualification: 'Ordinary Level',
    educationFile: null,
    termConditionFile: null,
    photoFile: null,
  });


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);





  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const storage = getStorage();
      
      // Generate unique filenames with timestamps
      const timestamp = Date.now();
      



      // Upload education certificate file
      let educationUrl = null;

// Upload only if the course requires the file
if (formData.educationFile) {
  const educationFileName = `education_${timestamp}_${formData.educationFile.name}`;
  const educationRef = ref(storage, `courseRegistration/${educationFileName}`);
  await uploadBytes(educationRef, formData.educationFile);
  educationUrl = await getDownloadURL(educationRef);
}






      // Upload terms and conditions file
      const termsFileName = `terms_${timestamp}_${formData.termConditionFile.name}`;
      const termsRef = ref(storage, `courseRegistration/${termsFileName}`);
      await uploadBytes(termsRef, formData.termConditionFile);
      const termConditionUrl = await getDownloadURL(termsRef);



      // Upload photo
      const photoFileName = `photo_${timestamp}_${formData.photoFile.name}`;
      const photoRef = ref(storage, `courseRegistration/${photoFileName}`);
      await uploadBytes(photoRef, formData.photoFile);
      const photoUrl = await getDownloadURL(photoRef);

      // Prepare data for Firestore
      const registrationData = {
        type: "assessor_mentor",
        email: formData.email,
        name: formData.name,
        contactNo: formData.contactNo,
        correspondentAddress: formData.correspondentAddress,
        nicPassportNo: formData.nicPassportNo,
        academicQualification: formData.academicQualification,
        educationUrl,
        termConditionUrl,
        photoUrl,
        status: 'pending',
        createdAt: serverTimestamp(),
      };

      // Save to Firestore
      await addDoc(collection(db, 'assessorMentorRegistration'), registrationData);

      // Prepare email data
      const emailData = {
        registrationType: "Assessor / Mentor Registration",
        name: formData.name,
        email: formData.email,
        contactNo: formData.contactNo,
        correspondentAddress: formData.correspondentAddress,
        nicPassportNo: formData.nicPassportNo,
        academicQualification: formData.academicQualification,
        educationUrl,
        termConditionUrl,
        photoUrl,
      };

      // Send email
      await emailjs.send(
        'service_eljxgdl',
        'template_i1tvar4',
        emailData,
        'SZeI-OQytanlYnI6L'
      );

      // Reset form after successful submission
      setFormData({ 

        name: '',
        email: '',
        contactNo: '',
        correspondentAddress: '',
        nicPassportNo: '',
        academicQualification: 'Ordinary Level',
        educationFile: null,
        termConditionFile: null,
        photoFile: null,
      });

      alert('Registration submitted successfully!');
    } catch (err) {
      console.error('Failed to submit registration:', err);
      setSubmitError('Failed to submit registration. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  


  return (
    <div className="course-registration">
    <h2>Assessor / Mentor Registration Form</h2>


      <form onSubmit={handleSubmit}>

        <div>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Contact No:</label>
          <input
            type="text"
            name="contactNo"
            placeholder="Enter your contact no"
            value={formData.contactNo}
            onChange={handleChange}
            required
            maxLength="10"
            pattern="\d{10}"
            title="Please enter a valid 10-digit contact number."
          />
        </div>


        <div>
          <label>Correspondent Address:</label>
          <input
            type="text"
            name="correspondentAddress"
            placeholder="Enter your correspondent address"
            value={formData.correspondentAddress}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>NIC / Passport No:</label>
          <input
            type="text"
            name="nicPassportNo"
            placeholder="Enter your NIC or Passport no"
            value={formData.nicPassportNo}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Academic Qualification:</label>
          <select
            name="academicQualification"
            value={formData.academicQualification}
            onChange={handleChange}
            required
          >
            <option value="Ordinary Level">Ordinary Level</option>
            <option value="Advanced Level">Advanced Level</option>
          </select>
        </div>

        



        <div>
            <label>Upload Certificate Level / Diploma / Higher Diploma certificate :</label>
            <input
            type="file"
            name="educationFile"
            style={{ all: "unset", display: "block", border: "2px solid blue" }}
            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required 
            />
        </div>









          <div>
        <label>Upload your National Identity Card copy (Front & rear side):</label>
          <input
            type="file"
            name="termConditionFile" 

            style={{ all: 'unset', display: 'block', border: '2px solid blue' }}



            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required
          />
        </div>







        <div>
          <label>upload a high-resolution passport-size photograph with a white background (Scanned hard copies are not acceptable) :</label>
          <input
            type="file"
            name="photoFile"

          style={{ all: 'unset', display: 'block', border: '2px solid blue' }}


            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required
          />
        </div>


        <div>
        <button 
            className="reg-submit-button" 
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>




    </div>
  );
}

export default AssessorMentorApply;
